import React from 'react';

import {
  t,
} from '../../helpers';

import './Contact.css';

const handleMailClick = () => {
  const mailaddress = '\x6C\x75\x64\x6F\x76\x69\x63\x40\x6C\x72\x64\x78\x2E\x62\x65';
  window.location.href = `mailto:${mailaddress}`;
};

const Contact = () => (
  <section id="contact" className="content-section text-center">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.text')}</p>
          <ul className="list-inline banner-social-buttons">
            <li className="list-inline-item">
              <a
                href="https://www.linkedin.com/in/ludovicradoux"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-default btn-lg"
              >
                <i className="fa fa-linkedin fa-fw" />
                <span className="network-name">
                  {t('contact.buttons.linkedin')}
                </span>
              </a>
            </li>
            <li className="list-inline-item">
              <button
                onClick={handleMailClick}
                className="btn btn-default btn-lg"
                id="mail-link"
              >
                <i className="fa fa-envelope fa-fw" />
                <span className="network-name">
                  {t('contact.buttons.email')}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js